var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToreadCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 1.125H3.375C3.06387 1.125 2.8125 1.37637 2.8125 1.6875V16.3125C2.8125 16.6236 3.06387 16.875 3.375 16.875H14.625C14.9361 16.875 15.1875 16.6236 15.1875 16.3125V1.6875C15.1875 1.37637 14.9361 1.125 14.625 1.125ZM10.0547 2.39062H11.7422V6.08027L10.9248 5.48438L10.0547 6.10664V2.39062ZM4.07812 15.6094V2.39062H9V7.60957C9 7.66758 9.01758 7.72559 9.05273 7.77305C9.07408 7.80321 9.10119 7.82885 9.1325 7.84847C9.16381 7.86809 9.1987 7.88131 9.23516 7.88736C9.27161 7.89341 9.30891 7.89217 9.34488 7.88371C9.38085 7.87525 9.41479 7.85975 9.44473 7.83809L10.9178 6.78516L12.3486 7.8293C12.3961 7.86445 12.4541 7.88379 12.5139 7.88379C12.6686 7.88379 12.7951 7.75723 12.7951 7.60254V2.39062H13.9201V15.6094H4.07812Z",
    fill: "#9E7CFF",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7422 6.08027V2.39062H10.0547V6.10664L10.9248 5.48438L11.7422 6.08027Z",
    fill: "#9E7CFF",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7951 2.39062V7.60254C12.7951 7.75723 12.6686 7.88379 12.5139 7.88379C12.4541 7.88379 12.3961 7.86445 12.3486 7.8293L10.9178 6.78516L9.44473 7.83809C9.41479 7.85975 9.38085 7.87525 9.34488 7.88371C9.30891 7.89217 9.27161 7.89341 9.23516 7.88736C9.1987 7.88131 9.16381 7.86809 9.1325 7.84847C9.10119 7.82885 9.07408 7.80321 9.05273 7.77305C9.01758 7.72559 9 7.66758 9 7.60957V2.39062H4.07812V15.6094H13.9201V2.39062H12.7951Z",
    fill: "#9E7CFF",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToreadCheck);
export default __webpack_public_path__ + "static/media/toread-check.c307580fe07535ebfc8b94b14715886c.svg";
export { ForwardRef as ReactComponent };